// src/services/pointService.js
// 28차: getExpiringPoints(uid) — 30일 내 소멸 예정 포인트 조회
//        getPointHistoryAll(uid) — 포인트 내역 전체 조회 (만료 포함)
// 33차: addPoints / spendPoints DEPRECATED 처리
// 75차: 데드코드 정리 — getPointHistory 삭제(호출부 없음, getPointHistoryAll로 대체된 채 남아있었음)

import {
  collection, getDocs,
  query, where, orderBy,
} from 'firebase/firestore';
import { db } from './firebase';

// ─── 30일 내 소멸 예정 포인트 총액 조회 (28차 추가) ─────────────────────────
// MyPageScreen expiringPoints 배지 및 PointHistoryScreen 소멸 배너에 사용
export const getExpiringPoints = async (uid) => {
  const now     = new Date().toISOString();
  const soon    = new Date();
  soon.setDate(soon.getDate() + 30);
  const soonStr = soon.toISOString();

  try {
    const snap = await getDocs(
      query(
        collection(db, 'pointHistory'),
        where('uid',     '==', uid),
        where('type',    '==', 'earn'),
        where('expired', '==', false),
      ),
    );
    let total = 0;
    const items = [];
    snap.docs.forEach(d => {
      const data = d.data();
      if (data.expiresAt && data.expiresAt > now && data.expiresAt <= soonStr) {
        total += data.amount || 0;
        items.push({ id: d.id, ...data });
      }
    });
    return { total, items };
  } catch {
    return { total: 0, items: [] };
  }
};

// ─── 포인트 내역 전체 조회 (만료 항목 포함, 28차 추가) ───────────────────────
// PointHistoryScreen에서 사용
// 78차 69차: orderBy('date','desc')가 날짜(하루 단위) 기준이라, 같은 날 여러 건이 쌓이면
// 그 안에서의 순서가 보장되지 않아(Firestore가 동점 문서 순서를 정의하지 않음) 실제
// 발생 순서와 다르게 뒤죽박죽으로 보이던 버그 — 모든 문서에 항상 존재하는 서버
// 타임스탬프 createdAt으로 정렬 기준을 바꿔 진짜 발생 순서를 보장.
export const getPointHistoryAll = async (uid) => {
  const q = query(
    collection(db, 'pointHistory'),
    where('uid', '==', uid),
    orderBy('createdAt', 'desc'),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};